import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const ClientModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12.1876C5 10.4271 6.42714 9 8.1876 9H15.8124C17.5729 9 19 10.4271 19 12.1876V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V12.1876Z"
            fill="url(#paint0_linear_123_14394)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.21277 5.73566C4.34526 4.74205 5.19282 4 6.19523 4H17.8048C18.8072 4 19.6547 4.74206 19.7872 5.73566L20.4509 10.7127C20.4826 10.83 20.4997 10.9534 20.4999 11.0807L20.5003 11.0831C20.5003 11.0832 20.5002 11.0833 20.5001 11.0833C20.5 11.0833 20.4999 11.0834 20.4999 11.0835C20.4999 11.0836 20.4999 11.0836 20.4999 11.0837C20.4999 11.8661 19.8656 12.5003 19.0832 12.5003C18.3113 12.5003 17.6836 11.883 17.6669 11.1151C17.6501 11.883 17.0224 12.5003 16.2505 12.5003C15.4681 12.5003 14.8338 11.8661 14.8338 11.0837V11.0835C14.8338 11.0834 14.8337 11.0833 14.8336 11.0833C14.8335 11.0833 14.8334 11.0834 14.8334 11.0835V11.0837C14.8334 11.8661 14.1991 12.5003 13.4167 12.5003C12.6343 12.5003 12 11.8661 12 11.0837V11.0835C12 11.0834 11.9999 11.0833 11.9998 11.0833C11.9997 11.0833 11.9997 11.0834 11.9997 11.0835V11.0837C11.9997 11.8661 11.3654 12.5003 10.5829 12.5003C9.81109 12.5003 9.1834 11.8831 9.16658 11.1153C9.14975 11.8831 8.52207 12.5003 7.75021 12.5003C6.96778 12.5003 6.3335 11.8661 6.3335 11.0837V11.0835C6.3335 11.0834 6.33342 11.0833 6.33332 11.0833C6.33323 11.0833 6.33315 11.0834 6.33315 11.0835V11.0837C6.33315 11.8661 5.69887 12.5003 4.91644 12.5003C4.13401 12.5003 3.49973 11.8661 3.49973 11.0837V11.0833C3.49975 10.9542 3.51707 10.829 3.54949 10.7101L4.21277 5.73566Z"
            fill="url(#paint1_linear_123_14394)"
          />
          <path
            d="M13 15.5C13 14.6716 13.6716 14 14.5 14C15.3284 14 16 14.6716 16 15.5V20H13V15.5Z"
            fill="#552500"
          />
          <circle cx="9" cy="15.5" r="1.5" fill="#552500" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 6C8.27614 6 8.5 6.22386 8.5 6.5V9C8.5 9.27614 8.27614 9.5 8 9.5C7.72386 9.5 7.5 9.27614 7.5 9V6.5C7.5 6.22386 7.72386 6 8 6ZM10.5 6C10.7761 6 11 6.22386 11 6.5V9C11 9.27614 10.7761 9.5 10.5 9.5C10.2239 9.5 10 9.27614 10 9V6.5C10 6.22386 10.2239 6 10.5 6ZM14 6C14.2761 6 14.5 6.22386 14.5 6.5V9C14.5 9.27614 14.2761 9.5 14 9.5C13.7239 9.5 13.5 9.27614 13.5 9V6.5C13.5 6.22386 13.7239 6 14 6ZM16.5 6C16.7761 6 17 6.22386 17 6.5V9C17 9.27614 16.7761 9.5 16.5 9.5C16.2239 9.5 16 9.27614 16 9V6.5C16 6.22386 16.2239 6 16.5 6Z"
            fill="#552500"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14394"
              x1="8.5"
              y1="12"
              x2="8.83705"
              y2="19.9945"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F79B5C" />
              <stop offset="1" stop-color="#FCFF56" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_14394"
              x1="8"
              y1="4"
              x2="8.08867"
              y2="12.4994"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F79B5C" />
              <stop offset="1" stop-color="#FCFF56" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default ClientModule;
